const DataStudents = [
  {
    username: "Evelyn",
    assignment: "SCRUM",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W1D1-1",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Evelyn",
    assignment: "W1D2-1",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Evelyn",
    assignment: "W1D2-2",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W1D2-3",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Evelyn",
    assignment: "W1D2-4",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W1D2-5",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W1D3-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W1D3-2",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W1D3-4",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W1D3-5",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W1D3 - Project - Guess-the-number",
    difficulty: 5,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W1D4-1",
    difficulty: 4,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W1D4 - Project - Kleurentoggle",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W1D5 - Project - Galgje",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Evelyn",
    assignment: "W2D1-1",
    difficulty: 1,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W2D1-2",
    difficulty: 2,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W2D2-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W2D2-2",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W2D2-3",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W2D3-1",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W2D3-2",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Evelyn",
    assignment: "W2D3-3",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W2D4-1",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Evelyn",
    assignment: "W2D4-2",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W2D4-3",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Evelyn",
    assignment: "W2D5 - Project - Filmzoeker",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W3D1-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W3D1-2",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W3D1-3",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W3D1-4",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Evelyn",
    assignment: "W3D2-1",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W3D2-2",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Evelyn",
    assignment: "W3D2-3",
    difficulty: 3,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W3D3-1",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W3D3-2",
    difficulty: 4,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W3D3-3",
    difficulty: 3,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W3D3-4",
    difficulty: 4,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W3D4-1",
    difficulty: 5,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W3D4-2",
    difficulty: 1,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W3D5 - Project - Todo-List",
    difficulty: 2,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W4D2-1",
    difficulty: 1,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W4D2-2",
    difficulty: 1,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W4D2-3",
    difficulty: 1,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W4D2-4",
    difficulty: 1,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W4D3-1",
    difficulty: 1,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W4D3-2",
    difficulty: 1,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W4D3-3",
    difficulty: 1,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W4D3-4",
    difficulty: 1,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W4D3-5",
    difficulty: 1,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W4D3 - Project - Next-Level CSS",
    difficulty: 1,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W5D4-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Evelyn",
    assignment: "W5D5 - Project - Lil_Playlist",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Evelyn",
    assignment: "W6D1-1",
    difficulty: 5,
    enjoyment: 5,
  },
  {
    username: "Evelyn",
    assignment: "W6D2-1",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Evelyn",
    assignment: "W6D2 - Project - Eindopdracht",
    difficulty: 5,
    enjoyment: 5,
  },
  {
    username: "Aranka",
    assignment: "SCRUM",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W1D1-1",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W1D2-1",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W1D2-2",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Aranka",
    assignment: "W1D2-3",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W1D2-4",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W1D2-5",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Aranka",
    assignment: "W1D3-1",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Aranka",
    assignment: "W1D3-2",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W1D3-4",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Aranka",
    assignment: "W1D3-5",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W1D3 - Project - Guess-the-number",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W1D4-1",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Aranka",
    assignment: "W1D4 - Project - Kleurentoggle",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W1D5 - Project - Galgje",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W2D1-1",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Aranka",
    assignment: "W2D1-2",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Aranka",
    assignment: "W2D2-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Aranka",
    assignment: "W2D2-2",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Aranka",
    assignment: "W2D2-3",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Aranka",
    assignment: "W2D3-1",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W2D3-2",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W2D3-3",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W2D4-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Aranka",
    assignment: "W2D4-2",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W2D4-3",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W2D5 - Project - Filmzoeker",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Aranka",
    assignment: "W3D1-1",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Aranka",
    assignment: "W3D1-2",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Aranka",
    assignment: "W3D1-3",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Aranka",
    assignment: "W3D1-4",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W3D2-1",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W3D2-2",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W3D2-3",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W3D3-1",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Aranka",
    assignment: "W3D3-2",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W3D3-3",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W3D3-4",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W3D4-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W3D4-2",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Aranka",
    assignment: "W3D5 - Project - Todo-List",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W4D2-1",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W4D2-2",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Aranka",
    assignment: "W4D2-3",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Aranka",
    assignment: "W4D2-4",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Aranka",
    assignment: "W4D3-1",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W4D3-2",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Aranka",
    assignment: "W4D3-3",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W4D3-4",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W4D3-5",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W4D3 - Project - Next-Level CSS",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Aranka",
    assignment: "W5D4-1",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Aranka",
    assignment: "W5D5 - Project - Lil_Playlist",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Aranka",
    assignment: "W6D1-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Aranka",
    assignment: "W6D2-1",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Aranka",
    assignment: "W6D2 - Project - Eindopdracht",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "SCRUM",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Floris",
    assignment: "W1D1-1",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Floris",
    assignment: "W1D2-1",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W1D2-2",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "W1D2-3",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "W1D2-4",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "W1D2-5",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Floris",
    assignment: "W1D3-1",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "W1D3-2",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "W1D3-4",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W1D3-5",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "W1D3 - Project - Guess-the-number",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W1D4-1",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Floris",
    assignment: "W1D4 - Project - Kleurentoggle",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Floris",
    assignment: "W1D5 - Project - Galgje",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "W2D1-1",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W2D1-2",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Floris",
    assignment: "W2D2-1",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Floris",
    assignment: "W2D2-2",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W2D2-3",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W2D3-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Floris",
    assignment: "W2D3-2",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W2D3-3",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Floris",
    assignment: "W2D4-1",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "W2D4-2",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Floris",
    assignment: "W2D4-3",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Floris",
    assignment: "W2D5 - Project - Filmzoeker",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Floris",
    assignment: "W3D1-1",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Floris",
    assignment: "W3D1-2",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Floris",
    assignment: "W3D1-3",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Floris",
    assignment: "W3D1-4",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Floris",
    assignment: "W3D2-1",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W3D2-2",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W3D2-3",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W3D3-1",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "W3D3-2",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "W3D3-3",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Floris",
    assignment: "W3D3-4",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W3D4-1",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Floris",
    assignment: "W3D4-2",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W3D5 - Project - Todo-List",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W4D2-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "W4D2-2",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Floris",
    assignment: "W4D2-3",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "W4D2-4",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W4D3-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "W4D3-2",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Floris",
    assignment: "W4D3-3",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W4D3-4",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W4D3-5",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Floris",
    assignment: "W4D3 - Project - Next-Level CSS",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W5D4-1",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Floris",
    assignment: "W5D5 - Project - Lil_Playlist",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Floris",
    assignment: "W6D1-1",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Floris",
    assignment: "W6D2-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Floris",
    assignment: "W6D2 - Project - Eindopdracht",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "SCRUM",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Hector",
    assignment: "W1D1-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Hector",
    assignment: "W1D2-1",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Hector",
    assignment: "W1D2-2",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Hector",
    assignment: "W1D2-3",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Hector",
    assignment: "W1D2-4",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Hector",
    assignment: "W1D2-5",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W1D3-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Hector",
    assignment: "W1D3-2",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Hector",
    assignment: "W1D3-4",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W1D3-5",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Hector",
    assignment: "W1D3 - Project - Guess-the-number",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W1D4-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W1D4 - Project - Kleurentoggle",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Hector",
    assignment: "W1D5 - Project - Galgje",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Hector",
    assignment: "W2D1-1",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Hector",
    assignment: "W2D1-2",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Hector",
    assignment: "W2D2-1",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Hector",
    assignment: "W2D2-2",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Hector",
    assignment: "W2D2-3",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Hector",
    assignment: "W2D3-1",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W2D3-2",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Hector",
    assignment: "W2D3-3",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Hector",
    assignment: "W2D4-1",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Hector",
    assignment: "W2D4-2",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W2D4-3",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Hector",
    assignment: "W2D5 - Project - Filmzoeker",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W3D1-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W3D1-2",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Hector",
    assignment: "W3D1-3",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Hector",
    assignment: "W3D1-4",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Hector",
    assignment: "W3D2-1",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Hector",
    assignment: "W3D2-2",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Hector",
    assignment: "W3D2-3",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W3D3-1",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Hector",
    assignment: "W3D3-2",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W3D3-3",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Hector",
    assignment: "W3D3-4",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W3D4-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Hector",
    assignment: "W3D4-2",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Hector",
    assignment: "W3D5 - Project - Todo-List",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Hector",
    assignment: "W4D2-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W4D2-2",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W4D2-3",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Hector",
    assignment: "W4D2-4",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Hector",
    assignment: "W4D3-1",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Hector",
    assignment: "W4D3-2",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Hector",
    assignment: "W4D3-3",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W4D3-4",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Hector",
    assignment: "W4D3-5",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Hector",
    assignment: "W4D3 - Project - Next-Level CSS",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W5D4-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Hector",
    assignment: "W5D5 - Project - Lil_Playlist",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W6D1-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Hector",
    assignment: "W6D2-1",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Hector",
    assignment: "W6D2 - Project - Eindopdracht",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "SCRUM",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W1D1-1",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W1D2-1",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Martina",
    assignment: "W1D2-2",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W1D2-3",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W1D2-4",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Martina",
    assignment: "W1D2-5",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W1D3-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W1D3-2",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W1D3-4",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Martina",
    assignment: "W1D3-5",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W1D3 - Project - Guess-the-number",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Martina",
    assignment: "W1D4-1",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Martina",
    assignment: "W1D4 - Project - Kleurentoggle",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Martina",
    assignment: "W1D5 - Project - Galgje",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W2D1-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W2D1-2",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Martina",
    assignment: "W2D2-1",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W2D2-2",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Martina",
    assignment: "W2D2-3",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W2D3-1",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Martina",
    assignment: "W2D3-2",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W2D3-3",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Martina",
    assignment: "W2D4-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W2D4-2",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W2D4-3",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W2D5 - Project - Filmzoeker",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W3D1-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W3D1-2",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Martina",
    assignment: "W3D1-3",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W3D1-4",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Martina",
    assignment: "W3D2-1",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Martina",
    assignment: "W3D2-2",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W3D2-3",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W3D3-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W3D3-2",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W3D3-3",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Martina",
    assignment: "W3D3-4",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Martina",
    assignment: "W3D4-1",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W3D4-2",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W3D5 - Project - Todo-List",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Martina",
    assignment: "W4D2-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W4D2-2",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Martina",
    assignment: "W4D2-3",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W4D2-4",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W4D3-1",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W4D3-2",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Martina",
    assignment: "W4D3-3",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W4D3-4",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W4D3-5",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Martina",
    assignment: "W4D3 - Project - Next-Level CSS",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W5D4-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W5D5 - Project - Lil_Playlist",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W6D1-1",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Martina",
    assignment: "W6D2-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Martina",
    assignment: "W6D2 - Project - Eindopdracht",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Maurits",
    assignment: "SCRUM",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Maurits",
    assignment: "W1D1-1",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W1D2-1",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Maurits",
    assignment: "W1D2-2",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Maurits",
    assignment: "W1D2-3",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Maurits",
    assignment: "W1D2-4",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W1D2-5",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W1D3-1",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Maurits",
    assignment: "W1D3-2",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Maurits",
    assignment: "W1D3-4",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Maurits",
    assignment: "W1D3-5",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W1D3 - Project - Guess-the-number",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W1D4-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Maurits",
    assignment: "W1D4 - Project - Kleurentoggle",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W1D5 - Project - Galgje",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Maurits",
    assignment: "W2D1-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W2D1-2",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W2D2-1",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Maurits",
    assignment: "W2D2-2",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W2D2-3",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Maurits",
    assignment: "W2D3-1",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Maurits",
    assignment: "W2D3-2",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W2D3-3",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W2D4-1",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W2D4-2",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Maurits",
    assignment: "W2D4-3",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W2D5 - Project - Filmzoeker",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W3D1-1",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Maurits",
    assignment: "W3D1-2",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W3D1-3",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Maurits",
    assignment: "W3D1-4",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Maurits",
    assignment: "W3D2-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Maurits",
    assignment: "W3D2-2",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W3D2-3",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W3D3-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W3D3-2",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W3D3-3",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W3D3-4",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W3D4-1",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Maurits",
    assignment: "W3D4-2",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W3D5 - Project - Todo-List",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Maurits",
    assignment: "W4D2-1",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W4D2-2",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Maurits",
    assignment: "W4D2-3",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W4D2-4",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W4D3-1",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W4D3-2",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Maurits",
    assignment: "W4D3-3",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Maurits",
    assignment: "W4D3-4",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W4D3-5",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Maurits",
    assignment: "W4D3 - Project - Next-Level CSS",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W5D4-1",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W5D5 - Project - Lil_Playlist",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Maurits",
    assignment: "W6D1-1",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Maurits",
    assignment: "W6D2-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Maurits",
    assignment: "W6D2 - Project - Eindopdracht",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Rahima",
    assignment: "SCRUM",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W1D1-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W1D2-1",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W1D2-2",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Rahima",
    assignment: "W1D2-3",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Rahima",
    assignment: "W1D2-4",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Rahima",
    assignment: "W1D2-5",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Rahima",
    assignment: "W1D3-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Rahima",
    assignment: "W1D3-2",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W1D3-4",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Rahima",
    assignment: "W1D3-5",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Rahima",
    assignment: "W1D3 - Project - Guess-the-number",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Rahima",
    assignment: "W1D4-1",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Rahima",
    assignment: "W1D4 - Project - Kleurentoggle",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W1D5 - Project - Galgje",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Rahima",
    assignment: "W2D1-1",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Rahima",
    assignment: "W2D1-2",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Rahima",
    assignment: "W2D2-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Rahima",
    assignment: "W2D2-2",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Rahima",
    assignment: "W2D2-3",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Rahima",
    assignment: "W2D3-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Rahima",
    assignment: "W2D3-2",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W2D3-3",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Rahima",
    assignment: "W2D4-1",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W2D4-2",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W2D4-3",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Rahima",
    assignment: "W2D5 - Project - Filmzoeker",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Rahima",
    assignment: "W3D1-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Rahima",
    assignment: "W3D1-2",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Rahima",
    assignment: "W3D1-3",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Rahima",
    assignment: "W3D1-4",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W3D2-1",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Rahima",
    assignment: "W3D2-2",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W3D2-3",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Rahima",
    assignment: "W3D3-1",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Rahima",
    assignment: "W3D3-2",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W3D3-3",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W3D3-4",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Rahima",
    assignment: "W3D4-1",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Rahima",
    assignment: "W3D4-2",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Rahima",
    assignment: "W3D5 - Project - Todo-List",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W4D2-1",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W4D2-2",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Rahima",
    assignment: "W4D2-3",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Rahima",
    assignment: "W4D2-4",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Rahima",
    assignment: "W4D3-1",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Rahima",
    assignment: "W4D3-2",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Rahima",
    assignment: "W4D3-3",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Rahima",
    assignment: "W4D3-4",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Rahima",
    assignment: "W4D3-5",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Rahima",
    assignment: "W4D3 - Project - Next-Level CSS",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Rahima",
    assignment: "W5D4-1",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Rahima",
    assignment: "W5D5 - Project - Lil_Playlist",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Rahima",
    assignment: "W6D1-1",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W6D2-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Rahima",
    assignment: "W6D2 - Project - Eindopdracht",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Sandra",
    assignment: "SCRUM",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Sandra",
    assignment: "W1D1-1",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W1D2-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W1D2-2",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Sandra",
    assignment: "W1D2-3",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W1D2-4",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Sandra",
    assignment: "W1D2-5",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W1D3-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Sandra",
    assignment: "W1D3-2",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Sandra",
    assignment: "W1D3-4",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W1D3-5",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W1D3 - Project - Guess-the-number",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W1D4-1",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Sandra",
    assignment: "W1D4 - Project - Kleurentoggle",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W1D5 - Project - Galgje",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W2D1-1",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Sandra",
    assignment: "W2D1-2",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W2D2-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W2D2-2",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W2D2-3",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W2D3-1",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Sandra",
    assignment: "W2D3-2",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Sandra",
    assignment: "W2D3-3",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Sandra",
    assignment: "W2D4-1",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W2D4-2",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W2D4-3",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Sandra",
    assignment: "W2D5 - Project - Filmzoeker",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W3D1-1",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W3D1-2",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W3D1-3",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W3D1-4",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Sandra",
    assignment: "W3D2-1",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W3D2-2",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W3D2-3",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Sandra",
    assignment: "W3D3-1",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Sandra",
    assignment: "W3D3-2",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Sandra",
    assignment: "W3D3-3",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W3D3-4",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Sandra",
    assignment: "W3D4-1",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W3D4-2",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Sandra",
    assignment: "W3D5 - Project - Todo-List",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Sandra",
    assignment: "W4D2-1",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W4D2-2",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Sandra",
    assignment: "W4D2-3",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W4D2-4",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W4D3-1",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Sandra",
    assignment: "W4D3-2",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W4D3-3",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W4D3-4",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W4D3-5",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W4D3 - Project - Next-Level CSS",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W5D4-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Sandra",
    assignment: "W5D5 - Project - Lil_Playlist",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Sandra",
    assignment: "W6D1-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Sandra",
    assignment: "W6D2-1",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Sandra",
    assignment: "W6D2 - Project - Eindopdracht",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Wietske",
    assignment: "SCRUM",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Wietske",
    assignment: "W1D1-1",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Wietske",
    assignment: "W1D2-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W1D2-2",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Wietske",
    assignment: "W1D2-3",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Wietske",
    assignment: "W1D2-4",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Wietske",
    assignment: "W1D2-5",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W1D3-1",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Wietske",
    assignment: "W1D3-2",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W1D3-4",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Wietske",
    assignment: "W1D3-5",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W1D3 - Project - Guess-the-number",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W1D4-1",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W1D4 - Project - Kleurentoggle",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Wietske",
    assignment: "W1D5 - Project - Galgje",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Wietske",
    assignment: "W2D1-1",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Wietske",
    assignment: "W2D1-2",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Wietske",
    assignment: "W2D2-1",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Wietske",
    assignment: "W2D2-2",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W2D2-3",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W2D3-1",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Wietske",
    assignment: "W2D3-2",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Wietske",
    assignment: "W2D3-3",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Wietske",
    assignment: "W2D4-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Wietske",
    assignment: "W2D4-2",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W2D4-3",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Wietske",
    assignment: "W2D5 - Project - Filmzoeker",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Wietske",
    assignment: "W3D1-1",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Wietske",
    assignment: "W3D1-2",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W3D1-3",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Wietske",
    assignment: "W3D1-4",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W3D2-1",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Wietske",
    assignment: "W3D2-2",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Wietske",
    assignment: "W3D2-3",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W3D3-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W3D3-2",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Wietske",
    assignment: "W3D3-3",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Wietske",
    assignment: "W3D3-4",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W3D4-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W3D4-2",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Wietske",
    assignment: "W3D5 - Project - Todo-List",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W4D2-1",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Wietske",
    assignment: "W4D2-2",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W4D2-3",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Wietske",
    assignment: "W4D2-4",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Wietske",
    assignment: "W4D3-1",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Wietske",
    assignment: "W4D3-2",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Wietske",
    assignment: "W4D3-3",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W4D3-4",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Wietske",
    assignment: "W4D3-5",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Wietske",
    assignment: "W4D3 - Project - Next-Level CSS",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Wietske",
    assignment: "W5D4-1",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Wietske",
    assignment: "W5D5 - Project - Lil_Playlist",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Wietske",
    assignment: "W6D1-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Wietske",
    assignment: "W6D2-1",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Wietske",
    assignment: "W6D2 - Project - Eindopdracht",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "SCRUM",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W1D1-1",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "W1D2-1",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Storm",
    assignment: "W1D2-2",
    difficulty: 1,
    enjoyment: 3,
  },
  {
    username: "Storm",
    assignment: "W1D2-3",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "W1D2-4",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Storm",
    assignment: "W1D2-5",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Storm",
    assignment: "W1D3-1",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Storm",
    assignment: "W1D3-2",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W1D3-4",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W1D3-5",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "W1D3 - Project - Guess-the-number",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Storm",
    assignment: "W1D4-1",
    difficulty: 4,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "W1D4 - Project - Kleurentoggle",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "W1D5 - Project - Galgje",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Storm",
    assignment: "W2D1-1",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Storm",
    assignment: "W2D1-2",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "W2D2-1",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Storm",
    assignment: "W2D2-2",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W2D2-3",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W2D3-1",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Storm",
    assignment: "W2D3-2",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Storm",
    assignment: "W2D3-3",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "W2D4-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Storm",
    assignment: "W2D4-2",
    difficulty: 4,
    enjoyment: 3,
  },
  {
    username: "Storm",
    assignment: "W2D4-3",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W2D5 - Project - Filmzoeker",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W3D1-1",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W3D1-2",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "W3D1-3",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "W3D1-4",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Storm",
    assignment: "W3D2-1",
    difficulty: 1,
    enjoyment: 4,
  },
  {
    username: "Storm",
    assignment: "W3D2-2",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Storm",
    assignment: "W3D2-3",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Storm",
    assignment: "W3D3-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Storm",
    assignment: "W3D3-2",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "W3D3-3",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W3D3-4",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W3D4-1",
    difficulty: 2,
    enjoyment: 4,
  },
  {
    username: "Storm",
    assignment: "W3D4-2",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Storm",
    assignment: "W3D5 - Project - Todo-List",
    difficulty: 3,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "W4D2-1",
    difficulty: 2,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W4D2-2",
    difficulty: 3,
    enjoyment: 3,
  },
  {
    username: "Storm",
    assignment: "W4D2-3",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "W4D2-4",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Storm",
    assignment: "W4D3-1",
    difficulty: 3,
    enjoyment: 4,
  },
  {
    username: "Storm",
    assignment: "W4D3-2",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Storm",
    assignment: "W4D3-3",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W4D3-4",
    difficulty: 3,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W4D3-5",
    difficulty: 2,
    enjoyment: 3,
  },
  {
    username: "Storm",
    assignment: "W4D3 - Project - Next-Level CSS",
    difficulty: 4,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W5D4-1",
    difficulty: 2,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "W5D5 - Project - Lil_Playlist",
    difficulty: 1,
    enjoyment: 2,
  },
  {
    username: "Storm",
    assignment: "W6D1-1",
    difficulty: 4,
    enjoyment: 4,
  },
  {
    username: "Storm",
    assignment: "W6D2-1",
    difficulty: 1,
    enjoyment: 1,
  },
  {
    username: "Storm",
    assignment: "W6D2 - Project - Eindopdracht",
    difficulty: 3,
    enjoyment: 3,
  },
];

export default DataStudents;
